import { render, staticRenderFns } from "./ProductsUpload.vue?vue&type=template&id=25b4d4d9&"
import script from "./ProductsUpload.vue?vue&type=script&lang=js&"
export * from "./ProductsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports